export default __webpack_public_path__ + "warning.3c4b55e4.svg";